import { API_URL } from 'config';
import { makeAPICall } from './api';

export declare namespace API {
    export interface TLE {
        // More fields exist but are just an unpacking of the two lines.
        id: number;
        name: string;
        catalogue_number: number;
        elememt_set_number: number;
        epoch: string;
        uploaded: string;
        semimajor_axis: number;
        period: number;
        apogee: number;
        perigee: number;
        inclination: number;
        eccentricity: number;
        RAAN: number;
        line0: string;
        line1: string;
        line2: string;
    }
}

export interface TLE {
    id: number;
    name: string;
    catalogue_number: number;
    elememt_set_number: number;
    epoch: Date;
    uploaded: Date;
    semimajor_axis: number;
    period: number;
    apogee: number;
    perigee: number;
    inclination: number;
    eccentricity: number;
    RAAN: number;
    line0: string;
    line1: string;
    line2: string;
}

const TLES_ROUTE = '/tles';

export const mapAPIToTLE = ({ uploaded, epoch, ...rest }: API.TLE): TLE => ({
    ...rest,
    epoch: new Date(epoch),
    uploaded: new Date(uploaded),
});

export const listTLEs = makeAPICall<TLE[], void, { results: API.TLE[] }>(
    () => ({
        url: `${API_URL}${TLES_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToTLE),
);
